<script lang="ts">
  import { onMount } from "svelte";
  import { currentRoute } from "../store";

  let navOpen = false;

  function toggleNav(): void {
    const navMenu = document.getElementById("nav-menu");
    navOpen = !navOpen;
    if (navOpen) {
      navMenu?.classList.add("block");
      navMenu?.classList.remove("hidden");
    } else {
      navMenu?.classList.add("hidden");
      navMenu?.classList.remove("block");
    }
  }

  function navigate(route: string, e: Event): void {
    e.preventDefault();
    $currentRoute = route;
    if (navOpen) toggleNav();
  }

  function getNavClass(route: string, current: string): string {
    const base =
      "block lg:inline-block text-lg font-bold uppercase tracking-wider px-5 py-3 mx-1 transition duration-400 rounded-lg max-lg:w-full max-lg:mb-2 max-lg:-ml-2 ";
    if (route === current) {
      return (
        base +
        "bg-amber-400 text-sky-900 shadow-md shadow-amber-400/50 lg:-translate-y-1 lg:scale-105"
      );
    }
    return (
      base +
      "text-white hover:bg-amber-300 hover:text-sky-900 hover:-translate-y-1 hover:scale-105"
    );
  }

  onMount(() => {
    const navMenu = document.getElementById("nav-menu");
    navMenu?.classList.add("hidden");
  });
</script>

<header class="w-full fixed top-0 z-50">
  <nav
    class="flex items-center justify-between flex-wrap bg-sky-500 shadow-lg px-8 py-4"
  >
    <!-- Logo -->
    <div class="flex items-center flex-shrink-0 text-white mr-8">
      <a
        href="/#"
        on:click={(e) => navigate("Home", e)}
        class="hover:text-amber-400 transition duration-300"
      >
        <div class="flex items-center hover:scale-105 transition duration-300">
          <i class="fa-solid fa-store text-4xl mx-3"></i>
          <p class="font-black text-3xl tracking-wider uppercase">
            Global Bazar
          </p>
        </div>
      </a>
    </div>

    <!-- Mobile Menu Button -->
    <div class="block lg:hidden">
      <button
        class="flex items-center px-4 py-3 border-2 rounded-lg text-white border-white hover:text-amber-400 hover:border-amber-400 transition duration-300"
        on:click={() => toggleNav()}
      >
        <i class="fa-solid fa-bars text-2xl"><title>Menu</title></i>
      </button>
    </div>

    <!-- Navigation Tabs -->
    <div
      class="w-full block flex-grow lg:flex lg:items-center lg:w-auto lg:justify-end mt-4 lg:mt-0"
      id="nav-menu"
    >
      <div
        class="text-base flex flex-col lg:flex-row shadow-inner lg:shadow-none p-4 lg:p-0 bg-sky-600 lg:bg-transparent rounded-xl lg:rounded-none"
      >
        <a
          href="/#"
          on:click={(e) => navigate("Home", e)}
          class={getNavClass("Home", $currentRoute)}>Home</a
        >
        <a
          href="/#"
          on:click={(e) => navigate("Products", e)}
          class={getNavClass("Products", $currentRoute)}>Products</a
        >
        <a
          href="/#"
          on:click={(e) => navigate("Orders", e)}
          class={getNavClass("Orders", $currentRoute)}>Orders</a
        >
        <a
          href="/#"
          on:click={(e) => navigate("About Us", e)}
          class={getNavClass("About Us", $currentRoute)}>About Us</a
        >
        <a
          href="/#"
          on:click={(e) => navigate("Contact Us", e)}
          class={getNavClass("Contact Us", $currentRoute)}>Contact Us</a
        >
        <a
          href="/#"
          on:click={(e) => navigate("Admin", e)}
          class={getNavClass("Admin", $currentRoute)}>Admin</a
        >
      </div>
    </div>
  </nav>
</header>
